import { instance, publicApiInstance } from 'api/internaltools';

export const getKycDetails = async (entityId) => {
  return publicApiInstance.get(`v2/internaltools/rfi/entity/${entityId}`);
};

export const updateKycDetails = async (entityId, questions) => {
  return publicApiInstance.post(`v2/internaltools/rfi/entity/${entityId}`, questions);
};

export const createKycDetail = async (entityId, payload) => {
  return instance.post(`/entity/${entityId}/kyc/details`, payload);
};

export const getRfiSummary = async () => {
  return instance.get('rfi/summary/v2');
};

export const getRfiByType = async ({ type, page = 1, pageSize = 10 }) => {
  return instance.get('rfi/summary/v2', {
    params: { type, page, pageSize },
  });
};

export const submitRfiDetails = async (entityId, payload) => {
  return publicApiInstance.post(`v2/internaltools/submit/rfi/${entityId}`, payload);
};

export const getRfiTemplates = async () => {
  return instance.get('rfi/templates');
};

export const getKybRfiSummary = async () => {
  return instance.get('/rfi/summary/kyb');
};

export const getKybRfiByType = async ({ type, page = 1, pageSize = 10 }) => {
  return instance.get('/rfi/summary/kyb', {
    params: { type, page, pageSize },
  });
};

export const getPartnerInitiatedKycs = async ({ partnerCode, page = 1, pageSize = 10 }) => {
  return instance.get('kycs/initiated/partner', {
    params: { partnerCode, page, pageSize },
  });
};

export const getKycPartnerSubmission = async (kycId) => {
  return instance.get(`kyc/${kycId}/partner-submission`);
};

export const submitKycToPartner = async (payload) => {
  return instance.post('kyc/submit/partner', payload);
};
